<template>
    <div class="videoPlay">
        <video width="100%" ref="videoRef" @loadstart="isactive = true" @play="isactive = false"
        @pause="isactive = true" @ended="isactive = false" :poster="posterSrc" controls="controls">
            <source :src="src" type="video/mp4" />
        </video>
        <img v-show="isactive" class="staticImg" @click="playVideo()" src="../assets/video_icon_play.png" alt="">
    </div>
</template>
<script>
export default {
    props:{
       src:{
         type:String,
         required: true
       },
       posterSrc:{
          type:String,
          required: true
        }
    },
    data(){
       return {
         isactive:true
       }
    },
    created(){
        
    },
    methods:{
        playVideo() {
            const video = this.$refs.videoRef;
            if(video.paused) {
                video.play();
            } else {
                video.pause();
            }
        },
    }
}
</script>
<style lang="less" scoped>
.videoPlay{
    position: relative;
    height: 4rem;
    width: 7.1rem;
    video{
        width: 100%;
        height: 100%;
    }
  .staticImg {
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: calc(50% - 0.61rem);
    left: calc(50% - 0.61rem);
    cursor: pointer;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/videoPlay.vue